import {AfterViewInit, Component,  ElementRef, OnDestroy, Input, OnInit, ViewChild} from '@angular/core';
import {Observable, from, Subscription} from "rxjs";
import {ActivatedRoute, Params} from '@angular/router';
 
import {StreamsService}  from "../../services/streams.service";
import {StreamProject} from "../../interfaces";
import {switchMap, map, delay} from 'rxjs/operators'; 
import { NbDialogRef, NbDialogService,NbGlobalPosition, NbToastrService } from '@nebular/theme';
 
///getToken 
//streaming

@Component({
  selector: 'app-stream-settings',
  templateUrl: './stream-settings.component.html',
  styleUrls: ['./stream-settings.component.scss'],
})
export class StreamSettingsComponent implements OnInit, OnDestroy{

 
   
  @Input() stream: StreamProject;
  @Input() hasSignal: boolean;
  @Input() chatMode: boolean = false;
  @Input() onRestreamSaved: any;
    @Input() socket: any;
   buttonsDisabled:boolean = false
 

  showTransformed:boolean = false
 disableSeekLine:boolean = false
deleteOnComplete:boolean = false
chatNonameEnabled:boolean = false
viewersInWatch:boolean = false

   constructor(
    public streamsService: StreamsService  ,
    protected ref: NbDialogRef<StreamSettingsComponent>,
    private toastrService: NbToastrService
     
    ){

  }
   ngOnInit() { 
          this.showTransformed = this.stream.showTransformed  
          this.disableSeekLine = this.stream.disableSeekLine  
          this.deleteOnComplete = this.stream.deleteOnComplete  
	  this.chatNonameEnabled = this.stream.chatNonameEnabled
 	  this.viewersInWatch = this.stream.viewersInWatch
  }


  closeModal() {
    this.ref.close();
  }

  
 
  change(event){


 }

updateSub$: any = null
   save(){
 

	   if(this.updateSub$){
		this.updateSub$.unsubsctibe()
	}
    


  

   this.updateSub$ = this.streamsService.updateSettings(this.stream._id,{showTransformed: this.showTransformed, 
									disableSeekLine: this.disableSeekLine, 
									deleteOnComplete: this.deleteOnComplete,
									chatNonameEnabled: this.chatNonameEnabled,
									viewersInWatch: this.viewersInWatch
	} ).subscribe(
     stream=>{
       
       	this.stream.showTransformed = stream.showTransformed       	
this.stream.disableSeekLine = stream.disableSeekLine
       	this.stream.deleteOnComplete = stream.deleteOnComplete
	       	this.stream.chatNonameEnabled = stream.chatNonameEnabled
		 this.stream.viewersInWatch = stream.viewersInWatch
	this.buttonsDisabled = true

	if(this.socket){
		this.socket.emit('changeSettings',{deleteOnComplete: stream.deleteOnComplete, viewersInWatch: stream.viewersInWatch  })
	}

     this.toastrService.show('','Налаштування збережені',{
      status: 'success',
      position: <NbGlobalPosition>'bottom-right'
        })
 
    },error =>{ 
		this.buttonsDisabled = false
     // MaterialService.toast(error.error.message)
      this.toastrService.show('','Сталася помилка',{
        status: 'danger',
        position: <NbGlobalPosition>'bottom-right'
        })
    },
    ()=>{
 	this.closeModal()	 	
    }
  )


  }


  
   ngOnDestroy() { 
	if(this.updateSub$){
		this.updateSub$.unsubsctibe()
	}
    
   }
 
   
  
}
